import React from 'react';
import Container from 'react-bootstrap/Container';
import Nav from 'react-bootstrap/Nav';
import Navbar from 'react-bootstrap/Navbar';
import bentley_PNG20 from '../asset/bentley_PNG20.png';
import Button from 'react-bootstrap/Button';
import {Link} from 'react-router-dom';

export default function NavBar() {
  return (
    <Navbar bg="dark" data-bs-theme="dark">
        <Container>
          <Navbar.Brand href="#home"><a href="https://www.bentleymotors.com/en.html"><img src={bentley_PNG20} alt="" height='70px'/></a></Navbar.Brand>
          <Nav className="me-auto">
            <Nav.Link href="/">Home</Nav.Link>
            <Nav.Link href="about/">About</Nav.Link>
            <Nav.Link href="pricing/">Pricing</Nav.Link>
            <Nav.Link href="contacts/">Contact</Nav.Link>
          </Nav>
          <Nav className='nav-button'>
            <Link><Button variant="primary">Request Your Ride</Button></Link>
          </Nav>
        </Container>
      </Navbar>
  )
}
